import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetPublicPersonBySlugResponse } from './get-public-person-by-slug-response';
import { getPublicPersonBySlugResponseSchema } from './get-public-person-by-slug-response';

export async function getPublicPersonBySlugApi(
  slug: string,
): Promise<IValidatedResponse<IGetPublicPersonBySlugResponse>> {
  return getRequest<IGetPublicPersonBySlugResponse>({
    path: `/people/slug/${encodeURIComponent(slug)}/v1`,
    schema: getPublicPersonBySlugResponseSchema,
  });
}
